import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    flexBasis: '47%',
    overflow: 'auto hidden !important',
    maxHeight: '300px'
  },

  tooltipValue: {
    marginTop: '0.75rem',
    textAlign: 'center'
  }
}))

export default useStyles
